import { type AxiosRequestConfig } from 'axios'

const uploadAvatar = (data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/user/upload-avatar',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
}

export { uploadAvatar }
